import { AsyncLogicParams, HOST_URL } from './index';
import { getAccessManagementRoutes } from '../../../helpers';

const accessLogic: Array<AsyncLogicParams> = [
  {
    name: 'accessRequest',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: getAccessManagementRoutes(getState().toggles.accessManagementEnabled)
        .verify,
      data: {
        phoneNumber: payload.phoneNumber,
        deviceUuid: payload.deviceUuid,
        pinLength: payload.pinLength
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'phone_number',
    shouldSetGlobalAsyncProperties: false
  },
  {
    name: 'confirmCode',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'put',
      url: getAccessManagementRoutes(getState().toggles.accessManagementEnabled)
        .verifyConfirm,
      data: {
        phoneNumber: payload.phoneNumber,
        deviceUuid: payload.deviceUuid,
        confirmCode: payload.code
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'confirm_code',
    shouldSetGlobalAsyncProperties: true
  },
  {
    name: 'forgotPassword',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${HOST_URL(publicRuntimeConfig)}/auth/forgot`,
      data: {
        email: payload.email,
        accessToken: payload.accessToken
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'forgot_password'
  },
  {
    name: 'login',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${HOST_URL(publicRuntimeConfig)}/auth`,
      data: {
        phoneNumber: payload.phoneNumber,
        password: payload.password,
        accessToken: payload.accessToken
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    shouldSetGlobalAsyncProperties: true
  },
  {
    name: 'ltaResetPassword',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${publicRuntimeConfig.ltaIdentityAPIBaseURL}reset-password`,
      data: {
        url: payload.url,
        device_id: payload.device_id,
        password: payload.password
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'reset_password'
  },
  {
    name: 'validateResetPasswordToken',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: `${publicRuntimeConfig.ltaIdentityAPIBaseURL}validate-reset-password-token`,
      data: {
        url: payload.url
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'reset_password',
    shouldSetGlobalAsyncProperties: false
  },
  {
    name: 'voicePin',
    axiosConfig: (payload, publicRuntimeConfig, getState) => ({
      method: 'post',
      url: getAccessManagementRoutes(getState().toggles.accessManagementEnabled)
        .verifyVoice,
      data: {
        phoneNumber: payload.phoneNumber,
        deviceUuid: payload.deviceUuid
      },
      headers: {
        'client-ip-address': getState().user.ipAddress
      }
    }),
    registrationStep: 'confirm_code',
    shouldSetGlobalAsyncProperties: false
  }
];

export default accessLogic;
